export default {
    title: 'Objednání do servisu',
    titleBinding: 'Závazné objednání do servisu',
    titleInspector: 'Objednání vrácení vozidla s inspektorem',

    licensePlate: 'Registrační značka (RZ)',
    mileage: 'Stav tachometru (km)',
    mileageValidation: 'Prosíme zadejte stav tachometru.',

    contactSectionLabel: 'Kontaktní údaje',
    firstName: 'Jméno',
    firstNameValidation: 'Prosíme zadejte Vaše jméno.',
    lastName: 'Příjmení',
    lastNameValidation: 'Prosíme zadejte Vaše příjmení.',
    email: 'E-mail',
    emailValidation: 'Prosíme zadejte Váš e-mail.',
    emailValidationFormat: 'Zadaný e-mail neodpovídá požadovanému formátu.',
    phone: 'Telefon',
    phoneCountryCode: 'Kód země',
    phoneSelectCountry: 'Vyberte zemi',
    phoneNumberPlaceholder: 'Telefonní číslo',
    phoneNumberExample: 'Příklad: ',
    phoneValidation: 'Prosíme zadejte Vaše telefonní číslo.',
    phoneValidationFormat: 'Zadaný telefon neodpovídá požadovanému formátu.',

    servicingActionsSectionLabel: 'Požadované servisní úkony',
    servicingActionSectionLabel: 'Požadovaný servisní úkon',
    servicingActionSectionInfo: 'Prosíme zvolte 1 či více možností.',
    servicingActionSectionNote: 'Tento formulář neslouží pro objednání opravy po škodní události.<br />Pro objednání po škodní události nás prosím kontaktujte na čísle <a href="tel:+420296333666" class="phone-number-section-note">+420 296 333 666</a>.',
    servicingActionSectionValidation: 'Prosíme zvolte požadovaný servisní úkon.',
    servicingActionServiceInspectionLabel: 'Servisní kontrola',
    servicingActionServiceInspectionTooltip: 'Pravidelný servisní úkon předepsaný výrobcem s pevným rozsahem prací a materiálu. Informace o nutnosti provedení je zpravidla uvedena na přístrojovém desce vozidla nebo v dokumentaci k vozidlu.',
    servicingActionRepairLabel: 'Běžná oprava',
    servicingActionRepairTooltip: 'Opravy a výměny dílů podléhajících běžnému opotřebení – brzdy, dezinfekce klimatizace, oprava osvětlení, výměna stěračů atd.',
    servicingActionTechnicalInspectionLabel: 'STK',
    servicingActionTechnicalInspectionTooltip: 'Technická kontrola a měření emisí – legislativní povinnost.',
    servicingActionTechnicalInspectionAdditional: 'Ano, mám potřebné dokumenty k zajištění technické kontroly – velký technický průkaz k vozidlu a malý technický průkaz k vozidlu (osvědčení o registraci vozidla).',
    servicingActionCallingActionLabel: 'Svolávací akce',
    servicingActionCallingActionTooltip: 'Servisní zásah na vozidle na základě výzvy výrobce.',
    servicingActionServiceOilChangeLabel: 'Servis výměny oleje',
    servicingActionServiceOilChangeTooltip: 'Pravidelný servisní úkon předepsaný výrobcem s pevným rozsahem prací a materiálu. Informace o nutnosti provedení je zpravidla uvedena na přístrojovém desce vozidla (hláška servis oleje) nebo v dokumentaci k vozidlu.',
    servicingActionBreakdownLabel: 'Porucha',
    servicingActionBreakdownTooltip: 'Vozidla v nepojízdném stavu nebo ve stavu sníženého výkonu.',
    servicingActionOtherLabel: 'Jiné',
    servicingActionOtherTooltip: 'Např. montáž doplňků k vozidlu.',

    servicingActionInputTextPlaceholder: 'Prosíme popište, co konkrétně požadujete.',
    servicingActionInputTextValidation: 'Prosíme doplňte toto pole.',
    servicingActionInputCheckboxValidation: 'Prosíme zaškrtněte tuto hodnotu.',

    supplementaryServicesSectionLabel: 'Doplňkové služby',
    supplementaryServicesNotAgreed: 'služba není sjednaná',
    supplementaryServicesPickUpLabel: 'Pick-up',
    supplementaryServicesPickUpStreetLabel: 'Ulice a č.p.',
    supplementaryServicesPickUpStreetValidation: 'Prosíme doplňte ulici a č.p..',
    supplementaryServicesPickUpTownLabel: 'Město',
    supplementaryServicesPickUpTownValidation: 'Prosíme doplňte město.',
    supplementaryServicesPickUpZipLabel: 'PSČ',
    supplementaryServicesPickUpZipValidation: 'Prosíme doplňte PSČ.',
    supplementaryServicesPickUpAddressNotFound: 'Zadaná adresa nebyla nalezena.',
    supplementaryServicesReplacementCarLabel: 'Náhradní vozidlo',
    supplementaryServicesReplacementCarAdditional: 'Mám řidičské oprávnění pouze pro vozidla s automatickou převodovkou.',
    supplementaryServicesCarWashLabel: 'Mytí exteriéru vozu',

    selectionDateSectionLabel: 'Výběr termínu',
    selectionDateSectionValidation: 'Prosíme zvolte si termín.',
    selectionDateSectionSelectedSlotFirst: 'Vybraný slot',
    selectionDateSectionSelectedSlotSecond: 'je rezervovaný ještě',
    selectionDateSectionTimeLabel: 'Výběr času',
    selectionDateSectionTimeBrought: 'Čas přistavení vozidla',
    selectionDateSectionTimePickUp: 'Čas pick-upu',
    selectionDateSectionTimeValidation: 'Prosíme zvolte si čas.',
    selectionDateSectionAlreadyReserved: 'Tento termín je již rezervován jiným uživatelem. Vyberte si prosím jiný termín.',

    termSectionPickupLabel: 'V jakých termínech by Vám pick-up vyhovoval',
    termSectionServiceLabel: 'V jakých termínech by Vám servis vyhovoval',
    termSectionPreferredDateDescription: 'Vyplňte všechny termíny ve 3 různých dnech',
    termSectionPeriodDescription: 'Vyplňte termíny v období od - do',
    termSectionPreferredDatesLabel: 'Preferované datum',
    termSectionPreferredDatesValidation: 'Prosíme zvolte datum a čas.',
    termSectionPeriodLabel: 'Období od - do',
    termSectionPeriodValidation: 'Prosíme vyberte období od – do.',
    termSectionPeriodCondition: 'Prosíme vyberte období delší než 1 den.',
    termSectionTimeLabel: 'Čas',
    termSectionTimeValidation: 'Prosíme vyberte čas.',

    serviceSupplierLocation: 'V případě, že vybraný servis nebude mít ve zvolených termínech volné kapacity, souhlasím s objednáním do jiného servisu v dané lokalitě.',
    serviceSupplierLocationValidation: 'Prosíme vyberte hodnotu.',
    securityInfoFirst: 'Společnost Drivalia se zavazuje chránit a zabezpečit osobní údaje, které shromažďuje a zpracovává. Více informací o podmínkách zpracování osobních údajů naleznete v',
    securityInfoLink: 'https://www.drivalia.cz/prohlaseni-o-ochrane-soukromi/',
    securityInfoSecond: 'prohlášení o ochraně osobních údajů',
    mandatoryInfoFirst: 'Položky označené',
    mandatoryInfoSecond: 'jsou povinné.',

    submitFormButton: 'Odeslat formulář',
    successFormSubmit: 'Vážený kliente, Vaše žádost byla úspěšně odeslána. Očekávejte SMS potvrzení termínu objednání.',
    successInspectionFormSubmit: 'Vážený kliente, Vaše objednávka vrácení vozidla s inspektorem byla úspěšně odeslána.',
    warningFormSubmit: 'Formulář se nepodařilo odeslat, zkontrolujte prosím vyplněné hodnoty.',
    conflictFormSubmit: 'Formulář se nepodařilo odeslat. Pro dané vozidlo již evidujeme aktivní objednávku.',
    errorFormSubmit: 'Váš požadavek bohužel nelze odeslat přes formulář. Prosíme kontaktujte nás telefonicky na +420 296 333 666, volba 3.'
}
